import { isDropZonePinComponent, PinComponent } from '@lessonup/pins-shared';

// Type definition for dropzone settings with linkedPinComponent
interface DropzoneSettings {
  linkedPinComponent?: string[];
}

// Get active dropzones (selected or have linked components)
export const getActiveDropzoneIds = (pinComponents: PinComponent[], selectedPinComponentIds?: string[]) => {
  return pinComponents
    .filter((pinComponent) => isDropZonePinComponent(pinComponent))
    .filter((dropzone) => {
      const settings = dropzone.settings as DropzoneSettings;
      return (
        selectedPinComponentIds?.includes(dropzone.id) ||
        (settings.linkedPinComponent && settings.linkedPinComponent.length > 0)
      );
    })
    .map((dropzone) => dropzone.id);
};

// Check if a component is an active dropzone
export const isActiveDropzone = (pinComponentId: string, activeDropzoneIds: string[]) => {
  return activeDropzoneIds.includes(pinComponentId);
};
